export class Scaler {
  private margin = 10;
  constructor(
    private width: number,
    private height: number,
    private wheelSize: number
  ) {}

  get minSide(): number {
    return Math.min(this.width, this.height);
  }

  get pxPerMm(): number {
    return (this.minSide - 2 * this.margin) / this.wheelSize;
  }

  get schematicRimOuterDiameter(): number {
    return this.minSide - this.margin * 2;
  }

  get schematicRimInnerDiameter(): number {
    return this.schematicRimOuterDiameter * 0.92;
  }

  get schematicNearFlangeDiameter(): number {
    return this.schematicRimOuterDiameter * 0.25;
  }

  get schematicFarFlangeDiameter(): number {
    return this.schematicRimOuterDiameter * 0.3;
  }

  get schematicAxleDiameter(): number {
    return this.schematicRimOuterDiameter * 0.04;
  }

  get schematicNearFlangeHoleDiameter(): number {
    return this.schematicRimOuterDiameter * 0.02;
  }

  get schematicFarFlangeHoleDiameter(): number {
    return this.schematicNearFlangeHoleDiameter * 0.8;
  }

  get schematicRimHoleDiameter(): number {
    return this.schematicNearFlangeHoleDiameter;
  }

  get schematicNearRimHoleDiameter(): number {
    return this.schematicRimHoleDiameter * 1.2;
  }

  get schematicFarRimHoleDiameter(): number {
    return this.schematicRimHoleDiameter * 0.8;
  }

  get schematicNippleHoleDiameter(): number {
    return this.schematicRimHoleDiameter * 1.5;
  }
}
